module.exports = __webpack_public_path__ + "img/minus.05964fd9.svg";